module.exports = {"id":"204370","name":"Sander van de Streek","rating":"71","photo":"./data/images/photos/1/204370.png","club":{"name":"FC Utrecht","logo":"./data/images/clubs/FCUtrecht.png"},"positions":["MC","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SandervandeStreek0.json
// module id = 3818
// module chunks = 0